export default __webpack_public_path__ + "static/media/new_clever_logo.1b9b9506.svg";